import { GoogleChartWrapperChartType } from 'react-google-charts'
import styled from 'styled-components'

export const StyledBrazilChart = styled.div<{
  chartModel: GoogleChartWrapperChartType
}>`
  position: relative;
  text-align: center;
`

export const MapLegendContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;

  border-radius: 6px;
  border: 1px solid #c9c9cb;
  background: #fefefe;

  display: flex;
  width: 120px;
  height: 150px;
  padding: 1rem;
  flex-direction: column;
  align-items: center;
  gap: 5px;

  @media (max-width: 1025px) {
    width: 100px;
    height: 100px;
    padding: 0.5rem;
  }
`

export const LegendContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 10px;
`

export const GradientBar = styled.div<{ colorStart: string; colorEnd: string }>`
  width: 20px;
  height: 100%;
  background: linear-gradient(
    to bottom,
    ${(props) => props.colorStart},
    ${(props) => props.colorEnd}
  );
  border-radius: 4px;
  border: 1px solid #ccc;

  @media (max-width: 1025px) {
    height: 100%;
  }
`

export const LegendText = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`
